<template>
  <header
    class="sub-header-section"
    :class="{ 'sub-header-section--no-link': !execTransitionEventParent && backLink === '' }"
  >
    <template v-if="!canReturnToAppLink && backLink">
      <router-link
        v-if="backLink"
        :to="!isPurchasingInAppPurchase ? backLink : ''"
        class="sub-header-section__back-link"
      >
        <img :src="require('@/assets/img/icon/icon_chevron_left_18.svg')" alt="" />
      </router-link>
    </template>
    <template v-else-if="backLink">
      <a
        class="sub-header-section__back-link"
        :class="{ 'sub-header-section__back-link--disabled': isPurchasingInAppPurchase }"
        :href="backLink"
        :target="target"
        rel="noopener noreferrer"
      >
        <img :src="require('@/assets/img/icon/icon_chevron_left_18.svg')" alt="" />
      </a>
    </template>
    <template v-else-if="execTransitionEventParent">
      <a class="sub-header-section__back-link" href="javascript:void(0)" @click="onClick()">
        <img :src="require('@/assets/img/icon/icon_chevron_left_18.svg')" alt="" />
      </a>
    </template>
    <h2 class="sub-header-section__title" v-html="pageTitle" />
  </header>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'

/**
 * 共通下層用 サブヘッダーセクション
 */
export default defineComponent({
  name: 'SubHeaderSection',
  props: {
    /**
     * ページタイトル
     */
    pageTitle: {
      type: String,
      default: '',
    },
    /**
     * バックリンク
     */
    backLink: {
      type: String,
      default: '',
    },
    /**
     * アプリインストール済みの場合はアプリに戻るURLかどうか
     */
    canReturnToAppLink: {
      type: Boolean,
      default: false,
    },
    /**
     * 新しいタブやウインドウでリンク先を開くかどうか
     * falseの場合、現在のウィンドウで開く
     */
    isOpenAsBlank: {
      type: Boolean,
      required: false,
      default: true,
    },
    /**
     * 親側で遷移先の処理を行うかどうか
     */
    execTransitionEventParent: {
      type: Boolean,
      default: false,
    },
    /**
     * アプリ内課金購入処理実行中かどうか
     */
    isPurchasingInAppPurchase: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    /**
     * リンクの開く先を指定する。
     * @return string リンクを別画面で開くかどうか
     */
    const target = computed(() => (props.isOpenAsBlank ? '_blank' : '_self'))

    const onClick = () => {
      context.emit('onClick')
    }

    return {
      target,
      onClick,
    }
  },
})
</script>

<style lang="scss" scoped>
.sub-header-section {
  position: relative;
  z-index: 2;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: $subHeaderPaneHeight;
  padding: 0 min(#{convertPXtoVW(8)}, 24px);
  margin: 0 auto;
  background: $white;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 5%);

  &::after {
    display: block;
    content: '';
    width: 28px;
  }

  &--no-link {
    justify-content: center;

    &::after {
      display: none;
    }
  }

  &__back-link {
    width: 28px;

    &--disabled {
      pointer-events: none;
    }
  }

  &__title {
    @include fontSetTextMedium();

    font-weight: 700;
    color: $black20;
    text-align: center;
  }
}
</style>
